/**
 * Created by yqr on 2019/2/20.
 * 设置api请求的baseURL
 * 实际项目中建议该文件不纳入版本管理
 */

let baseURL;
// 智能客服iframe url
let maxkbURL;

// 开发环境
if (process.env.NODE_ENV === "development") {
  //gateway,sso服务跑在99服务器上，个人调试只需要启动web-service,transport(可选),api(可选)
  baseURL = "/api";
  // baseURL = "https://iotdemo.gdyuanpeng.com/api";
  // baseURL = "https://iot.gdyuanpeng.com:8003";
  // maxkbURL = "http://192.168.25.99:8090/ui/chat/fd4f6b876426f8fc";
  // 编译环境
} else {
  if (process.env.type === "test") {
    // 测试环境
    baseURL = "/api";
    maxkbURL = "http://192.168.25.99:8090/ui/chat/fd4f6b876426f8fc";
  } else if (process.env.type === "demo") {
    //演示环境
    baseURL = "/api";
    maxkbURL = "https://maxkb.gdyuanpeng.com/ui/chat/03c39afe5f27a089";
  } else if (process.env.type === "dwq") {
    //大湾区环境
    baseURL = "http://172.17.32.124:8003";
  } else if (process.env.type === "gza") {
    //港珠澳大桥环境
    baseURL = 'http://10.40.225.191:88/api'
  } else {
    // 园区物联网环境
    baseURL = 'https://iot.gdyuanpeng.com/api'

    // 康养IOT环境
    // baseURL = "https://kyiot.gdyuanpeng.com/api";

    maxkbURL = "https://maxkb.gdyuanpeng.com/ui/chat/03c39afe5f27a089";
  }
}

//websocket
const wsURL = "";

//sso地址，暂时不用
const ssoURL = "";

//sso登陆回调地址，暂时不用
const loginRedirectUri = "";
export default {
  baseURL: baseURL,
  ssoURL: ssoURL,
  loginRedirectUri: loginRedirectUri,
  wsURL: wsURL,
  isDev: true,
  maxkbURL: maxkbURL,
  env: process.env.type
};



// WEBPACK FOOTER //
// ./src/api/env.js